import { setShopifyImageSize } from '../utils/index.js'

/**
 * You can specify exact dimensions in pixels for an image's width and height, up to a maximum of 5760 x 5760 px.
 * @see https://shopify.dev/api/liquid/filters/url-filters#size-parameters
 */
export const imageUrlFormatter = {
  name: 'image_url',
  read(originalSrc?: string, width?: number, height?: number) {
    if (!originalSrc) {
      return ''
    }

    return setShopifyImageSize(originalSrc, width, height)
  },
}
